import { render, staticRenderFns } from "./HeroSliderUS.vue?vue&type=template&id=b6661c14&scoped=true&"
import script from "./HeroSliderUS.vue?vue&type=script&lang=js&"
export * from "./HeroSliderUS.vue?vue&type=script&lang=js&"
import style0 from "./HeroSliderUS.vue?vue&type=style&index=0&id=b6661c14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6661c14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
